import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocument32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDocument32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M24 25a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6v8h8zM18 5.828V11h5.172zM10 29h12a4 4 0 0 0 4-4V11.828a2 2 0 0 0-.586-1.414l-6.828-6.828A2 2 0 0 0 17.172 3H10a4 4 0 0 0-4 4v18a4 4 0 0 0 4 4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocument32);
